import { useMutation } from "@tanstack/react-query";
import api from "../../util/api";
import { historicRequest } from "../../@types/historic-types";

const postData = async (data: historicRequest) => {
    return await api.post("/historico", data);
};

export function useHistoricMutate() {
    const mutate = useMutation({
        mutationFn: postData
    });

    return mutate;
}